import type { Space } from '@mail/cross-sizes-utils';
import type { aiPhotoGenerationLoaderTextVariants } from 'reactApp/modules/aiPhotoGeneration/aiPhotoGeneration.constants';

export type AiPhotoGenerationImageStyleType = 'oil' | 'cartoon' | '3d' | 'pixel' | 'anime' | 'cyberpunk' | 'comic' | 'realism';

export enum EAiPhotoGenerationState {
    idle = 'idle',
    proccess = 'proccess',
    endAnimation = 'endAnimation', // Ответ от бэкенда получен, плавно завершаем анимацию генерации
    complete = 'complete',
    clamp = 'clamp',
}

export interface IAiGenerateImageRequest {
    prompt: string;
    style?: AiPhotoGenerationImageStyleType;
}

export interface IAiGenerationState {
    generation: {
        state: EAiPhotoGenerationState;
        percentage?: number;
        image?: string;
        size?: Space;
        time?: number;
        textVariant?: aiPhotoGenerationLoaderTextVariants;
        startTime?: number;
        saved?: boolean;
        rated?: boolean;
        commented?: boolean;
    };
    prompt?: string;
    style?: AiPhotoGenerationImageStyleType | null;
}

export interface IGenerateImageEnd {
    image: string;
    size: Space;
    time: number;
}

export interface IResetGenerationImage {
    savePrompt?: boolean;
}

export interface ISaveGeneratedImage {
    publishAfterSuccess?: boolean;
}

export interface ISetGenerationPhotoScreenState {
    state: EAiPhotoGenerationState;
}
